import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '~/stores/user'
import { useServerStore } from '~/stores/server'
import { promptLoginRequired } from '~/utils/auth'

function buildReturnUrl(path) {
  const base = import.meta.env.BASE_URL || '/'
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  if (base === '/') {
    return normalizedPath
  }

  return `${base.replace(/\/$/, '')}${normalizedPath}`
}

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('~/pages/index.vue'),
  },
  {
    path: '/history',
    name: 'history',
    meta: { requiresAuth: true },
    component: () => import('~/pages/history/index.vue'),
  },
  {
    path: '/mutasi',
    name: 'mutasi',
    meta: { requiresAuth: true },
    component: () => import('~/pages/mutasi/index.vue'),
  },
  {
    path: '/poin',
    name: 'poin',
    meta: { requiresAuth: true },
    component: () => import('~/pages/mutasi/index.vue'),
  },
  {
    path: '/syarat-ketentuan',
    name: 'syarat-ketentuan',
    meta: { requiresSnk: true },
    component: () => import('~/pages/syarat-ketentuan/index.vue'),
  },
  {
    path: '/kebijakan-privasi',
    name: 'kebijakan-privasi',
    meta: { requiresSnk: true },
    component: () => import('~/pages/kebijakan-privasi/index.vue'),
  },
  {
    path: '/history/:tenant_trx_user_id',
    name: 'history-detail',
    meta: { requiresAuth: true },
    component: () => import('~/pages/history/[tenant_trx_user_id].vue'),
  },
  {
    path: '/:category/:name',
    name: 'game-detail',
    component: () => import('~/pages/game/[name].vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'index' },
  },
]

const router = createRouter({
  history: createWebHistory('/web/'),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach(async (to) => {
  if (to.meta.requiresSnk) {
    const serverStore = useServerStore()
    await serverStore.ensureServerInfo()

    if (!serverStore.hasSnk) {
      return { name: 'index' }
    }
  }

  if (!to.meta.requiresAuth) {
    return true
  }

  const userStore = useUserStore()
  if (!userStore.isAuthenticated) {
    await userStore.ensureProfile()
  }

  if (userStore.isAuthenticated) {
    return true
  }

  promptLoginRequired(buildReturnUrl(to.fullPath))
  return { name: 'index' }
})

export default router
